export const Loading = ({ className = '' }: { className?: string }) => {
  return <div role="alert" aria-busy="true" aria-label="Loading" className="bars-5" />
}
